import React, { useState, useContext } from 'react';
import { Accounts_Login } from '../../api/API_Accounts';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../Contexts/AuthContext';
import { Context_UI } from '../../Contexts/Context_UI';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Divider from '../ERUMAUI/UI_Divider';

export default function Forms_Landing_Login({Loading, Set_Loading}) {
    const [Form_Data, Form_Data_Set] = useState(
        {
            Email: "",
            Password: ""
        }
    );
    var UI = useContext(Context_UI);

    const {Login} = useAuth();

    const navigate = useNavigate();

    const { Slide_Switch } = useStatus();

    
    

    const handleChange = (e) => {
        Form_Data_Set({ ...Form_Data, [e.target.name]: e.target.value });
        window.Element_Attribute_Set("Landing_Form_Message", "State", "Inactive");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (await UI.Input_Evaluate([
            {
                Type: "Text",
                ID: "Input_Login_Email"
            },
            {
                Type: "Text",
                ID: "Input_Login_Password"
            }
        ])) {
            const Email_Regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!Email_Regex.test(Form_Data.Email)) {
                // console.log("Invalid email");
                UI.Element_Attribute_Set("Landing_Form_Message", "State", "Active");
                UI.Element_InnerHTML_Set("Landing_Form_Message_Text", `Log in failed.<br/>${"The email is not of valid format."}`);
                UI.Element_Attribute_Set("Landing_Form_Message", "Indicator", "Negative");
                UI.Element_Attribute_Set("Form_Login", "State", "Active");
                UI.Element_Attribute_Set("Input_Login_Email", "Validation", "Error");
                Set_Loading(false);
                return;
            }
            try {
                UI.Element_Attribute_Set("Landing_Form_Message", "State", "Active");
                UI.Element_Attribute_Set("Landing_Form_Message", "Indicator", "Neutral");
                UI.Element_Attribute_Set("Form_Login", "State", "Inactive");
                UI.Element_InnerHTML_Set("Landing_Form_Message_Text", `Contacting the server. This may take a minute.`);
                Set_Loading(true);
                const res = await Accounts_Login(Form_Data);
                // console.log("Login successful.");
                Set_Loading(false);
                Login(res.data.Token);
                
                setTimeout(function () {
                    // navigate("/home");
                    // Slide_Switch("/home");
                }, 500);
            } catch (Error) {
                console.error(Error.response?.data || Error.message);
                UI.Element_Attribute_Set("Form_Login", "State", "Active");
                Set_Loading(false)
                UI.Element_Attribute_Set("Landing_Form_Message", "State", "Active");
                UI.Element_InnerHTML_Set("Landing_Form_Message_Text", `Log in failed.<br/>${Error.response?.data.message}`);
                UI.Element_Attribute_Set("Landing_Form_Message", "Indicator", "Negative");
                UI.Element_Attribute_Set("Input_Login_Email", "Validation", "Error");
                UI.Element_Attribute_Set("Input_Login_Password", "Validation", "Error");
            }
        }
        
    }
    return (
        <div className="Landing_Form_Content">
            <h1 className="Landing_Form_Title">
                Welcome back.
            </h1>
            {/* <UI_Divider Text="Login"/> */}
            <form className="Input_Form" id="Form_Login" Composition="Linear" onSubmit={handleSubmit} State="Active" style={{ marginBottom: "10px" }}>
                <UI_Input_Text
                    name="Email"
                    Label_Text="Email address"
                    Required={true}
                    Input_Placeholder="Email address"
                    id="Input_Login_Email"
                    disabled={Loading == true ? true : false}
                    onChange={handleChange}
                />
                {/* <label className="Input_Label">
                    Email address
                </label>
                <input name="Email" className="Input_Text" type="text" placeholder='Email address (required)' id="Input_Login_Email" disabled={Loading == true ? true : false} onChange={handleChange} /> */}
                <UI_Input_Text
                    name="Password"
                    Label_Text="Password"
                    Required={true}
                    Input_Placeholder="Password"
                    id="Input_Login_Password"
                    disabled={Loading == true ? true : false}
                    onChange={handleChange}
                    Input_Type="password"
                />
                {/* <label className="Input_Label">
                    Password
                </label>
                <input name="Password" className="Input_Text" type="password" placeholder='Password (required)' disabled={Loading == true ? true : false} onChange={handleChange} id="Input_Login_Password" /> */}
                <div className='Landing_Form_Message' id="Landing_Form_Message" State="Inactive">
                    <p className='Landing_Form_Message_Text' id='Landing_Form_Message_Text'>
                        Log in failed.
                    </p>
                </div>
                <button type="submit" className="General_Button" Override_Form_Composition disabled={Loading == true ? true : false} style={{marginTop: "10px"}}>
                    Log in
                </button>
            </form>
            <p className='General_Paragraph' style={{ textAlign: "center", marginTop: "20px", cursor: "pointer" }} onClick={() => navigate("/resetpassword")}>
                <u>Forgot password?</u>
            </p>
            {/* <UI_Divider/> */}
            <div className="Landing_Form_AltPagePrompt" State={Loading ? "Inactive" : "Active"}>
                <h4 className="Landing_Form_AltPagePrompt_Title">
                    Don't have an account?
                </h4>
                <button className="General_Button" onClick={() => {
                    UI.Element_Attribute_Set('Landing_Form', 'Form', 'Register');
                    UI.Element_Attribute_Set('Landing_Logo_DR_Image', 'State', 'Inactive');
                    UI.Element_Attribute_Set('Landing_Logo_RED_Image', 'State', 'Inactive');
                }} disabled={Loading == true ? true : false}>
                    Register
                </button>
            </div>
        </div>
    );
}
